import React from 'react';

export default function ExpenseReport() {
  return <div>ExpenseReport</div>;
}
